var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NumberFormat from "./util/NumberFormat.js";
import LocaleManager from "../localization/LocaleManager.js";
class NumberHelper {
  static getLocalizedFormatter(formatConfig) {
    if ((formatConfig == null ? void 0 : formatConfig.style) === "currency" && !formatConfig.currency) {
      formatConfig.currency = LocaleManager.locale.NumberFormat.currency;
    }
    return typeof formatConfig === "string" ? NumberFormat.get({ locale: LocaleManager.localeCode, template: formatConfig }) : (formatConfig == null ? void 0 : formatConfig.locale) != null ? NumberFormat.get(formatConfig) : NumberFormat.get(Object.assign({}, formatConfig, { locale: LocaleManager.localeCode }));
  }
}
__publicField(NumberHelper, "$name", "NumberHelper");
NumberHelper._$name = "NumberHelper";
export {
  NumberHelper as default
};
